// Small pure 2D (XZ-plane) geometry helpers shared by the floor slices.

// Closest point to (px,pz) on the segment (ax,az)→(bx,bz), with its distance.
export function closestOnSeg(
  px: number,
  pz: number,
  ax: number,
  az: number,
  bx: number,
  bz: number,
): { x: number; z: number; d: number } {
  const dx = bx - ax;
  const dz = bz - az;
  const len2 = dx * dx + dz * dz;
  let t = len2 > 0 ? ((px - ax) * dx + (pz - az) * dz) / len2 : 0;
  t = Math.max(0, Math.min(1, t));
  const x = ax + dx * t;
  const z = az + dz * t;
  return { x, z, d: Math.hypot(px - x, pz - z) };
}
